import React from 'react';
import { Trash2, X, CheckSquare, Square } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Composant toolbar réutilisable pour les actions en masse
 * 
 * @param {number} selectedCount - Nombre d'éléments sélectionnés
 * @param {number} totalCount - Nombre total d'éléments disponibles
 * @param {Function} onSelectAll - Callback pour sélectionner tous les éléments
 * @param {Function} onDeselectAll - Callback pour désélectionner tous
 * @param {Function} onBulkDelete - Callback pour suppression multiple
 * @param {Array} customActions - Tableau d'actions personnalisées { label, icon, onClick, variant }
 * @param {string} entityName - Nom de l'entité (au singulier)
 */
export default function BulkActionsToolbar({
  selectedCount,
  totalCount,
  onSelectAll,
  onDeselectAll,
  onBulkDelete,
  customActions = [],
  entityName = "élément"
}) {
  if (selectedCount === 0) return null;

  const allSelected = selectedCount === totalCount;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          {allSelected ? (
            <CheckSquare className="h-5 w-5 text-blue-600" />
          ) : (
            <Square className="h-5 w-5 text-blue-600" />
          )}
          <span className="font-medium text-blue-900">
            {selectedCount} {entityName}(s) sélectionné(s)
          </span>
        </div>

        <Button
          variant="ghost"
          size="sm"
          onClick={allSelected ? onDeselectAll : onSelectAll}
          className="text-blue-700 hover:text-blue-900 hover:bg-blue-100"
        >
          {allSelected ? "Désélectionner tout" : "Tout sélectionner"}
        </Button>
      </div>

      <div className="flex items-center gap-2">
        {customActions.map((action, idx) => (
          <Button
            key={idx}
            variant={action.variant || "outline"}
            size="sm"
            onClick={action.onClick}
            className="gap-2"
          >
            {action.icon}
            {action.label}
          </Button>
        ))}

        <Button
          variant="outline"
          size="sm"
          onClick={onDeselectAll}
          className="gap-2"
        >
          <X className="h-4 w-4" />
          Annuler
        </Button>

        <Button
          variant="destructive"
          size="sm"
          onClick={onBulkDelete}
          className="gap-2"
        >
          <Trash2 className="h-4 w-4" />
          Supprimer la sélection
        </Button>
      </div>
    </div>
  );
}
